import { Message } from './Message';


export class DeleteCommand extends Message
{
    constructor(
        Id: string)
    {
        super("Delete", { Id });
    }
}
